import { MenuCategory, RESTAURANT_CONSTANTS } from '@/lib/index';
import { IMAGES } from '@/assets/images';

export const restaurantInfo = {
  name: RESTAURANT_CONSTANTS.NAME,
  owner: RESTAURANT_CONSTANTS.OWNER,
  address: RESTAURANT_CONSTANTS.ADDRESS,
  email: RESTAURANT_CONSTANTS.EMAIL,
  whatsapp: RESTAURANT_CONSTANTS.WHATSAPP_LINK,
  instagram: RESTAURANT_CONSTANTS.INSTAGRAM_LINK,
  hours: RESTAURANT_CONSTANTS.HOURS,
  cuisine: RESTAURANT_CONSTANTS.CUISINE_TYPES,
  description: "Service-Pépinière Blessing est dirigé par Mabaga Karine, passionnée de cuisine africaine et européenne. Tous les plats sont préparés avec des produits frais et faits maison pour offrir des saveurs authentiques.",
};

export const menuData: MenuCategory[] = [
  {
    id: 'entrees',
    title: 'Entrées',
    items: [
      {
        id: 'entree-1',
        name: 'Salade composée citron',
        price: 5,
        category: 'Entrées',
        description: 'Fraîcheur acidulée aux légumes croquants.'
      },
      {
        id: 'entree-2',
        name: 'Salade composée cacahuète',
        price: 5,
        category: 'Entrées',
        description: 'Légumes croquants avec une touche croquante de cacahuètes.'
      },
      {
        id: 'entree-3',
        name: "Salade d'avocat",
        price: 7,
        category: 'Entrées',
        description: 'Avocats crémeux et assaisonnement maison.'
      },
      {
        id: 'entree-4',
        name: '3 Pastels',
        price: 5,
        category: 'Entrées',
        description: 'Petits chaussons frits croustillants.'
      },
      {
        id: 'entree-5',
        name: '8 Pastels',
        price: 10,
        category: 'Entrées',
        description: 'Grand format pour les gourmands.'
      }
    ]
  },
  {
    id: 'plats-signatures',
    title: 'Plats Signatures',
    items: [
      {
        id: 'plat-1',
        name: 'Saint-Jacques + purée au choix',
        price: 30,
        category: 'Plats Signatures',
        image: IMAGES.EUROPEAN_CUISINE_2,
        description: 'Noix de Saint-Jacques poêlées servies avec une purée onctueuse.'
      },
      {
        id: 'plat-2',
        name: 'Nsaka-madesu + poulet',
        price: 20,
        category: 'Plats Signatures',
        image: IMAGES.CAPTURE_D_CRAN6108,
        description: 'Plat traditionnel à base de feuilles de manioc et haricots, servi avec du poulet.'
      },
      {
        id: 'plat-3',
        name: 'Nsaka-nsaka + semoule + poulet',
        price: 19,
        category: 'Plats Signatures',
        image: IMAGES.CAPTURE_D_CRAN6160,
        description: 'Feuilles de manioc préparées avec soin, accompagnées de semoule et poulet.'
      },
      {
        id: 'plat-4',
        name: 'Nsaka-nsaka arachide + riz ou semoule',
        price: 20,
        category: 'Plats Signatures',
        image: IMAGES.AFRICAN_CUISINE_3,
        description: 'Variante onctueuse à l\'arachide, accompagnée de riz ou semoule.'
      },
      {
        id: 'plat-5',
        name: 'Brochettes + banane plantain',
        price: 13,
        category: 'Plats Signatures',
        image: IMAGES.CAPTURE_D_CRAN5257,
        description: 'Brochettes de viande grillées et plantains frits.'
      },
      {
        id: 'plat-6',
        name: 'Riz + brochettes + plantain',
        price: 17,
        category: 'Plats Signatures',
        image: IMAGES.AFRICAN_CUISINE_5,
        description: 'Assiette complète avec riz, brochettes et plantains.'
      },
      {
        id: 'plat-7',
        name: 'Attiéké + alloco + poisson',
        price: 19,
        category: 'Plats Signatures',
        image: IMAGES.AFRICAN_CUISINE_8,
        description: 'Semoule de manioc, bananes frites et poisson grillé.'
      },
      {
        id: 'plat-8',
        name: 'Poulet rôti + pommes de terre',
        price: 35,
        category: 'Plats Signatures',
        image: IMAGES.CAPTURE_D_CRAN3261,
        description: 'Poulet rôti entier avec ses pommes de terre dorées au four.'
      },
      {
        id: 'plat-9',
        name: 'Gratin dauphinois',
        price: 10,
        category: 'Plats Signatures',
        image: IMAGES.EUROPEAN_CUISINE_5,
        description: 'Classique français crémeux et fondant.'
      },
      {
        id: 'plat-10',
        name: 'Burger XL + frites',
        price: 13,
        category: 'Plats Signatures',
        image: IMAGES.EUROPEAN_CUISINE_1,
        description: 'Généreux burger maison servi avec frites croustillantes.'
      }
    ]
  },
  {
    id: 'menu-enfant',
    title: 'Menu Enfant',
    items: [
      {
        id: 'enfant-1',
        name: 'Poulet + sauce tomate + boisson',
        price: 10,
        category: 'Menu Enfant',
        isChildMenu: true,
        description: 'Accompagnement au choix : riz, frites ou plantain. Boisson incluse.'
      }
    ]
  },
  {
    id: 'accompagnements',
    title: 'Accompagnements',
    items: [
      { id: 'acc-1', name: 'Riz', price: 5, category: 'Accompagnements' },
      { id: 'acc-2', name: 'Attiéké', price: 6, category: 'Accompagnements' },
      { id: 'acc-3', name: 'Alloco', price: 5, category: 'Accompagnements' },
      { id: 'acc-4', name: 'Plantain', price: 5, category: 'Accompagnements' },
      { id: 'acc-5', name: 'Frites', price: 5, category: 'Accompagnements' },
      { id: 'acc-6', name: 'Semoule', price: 5, category: 'Accompagnements' }
    ]
  },
  {
    id: 'desserts',
    title: 'Desserts',
    items: [
      {
        id: 'dessert-1',
        name: 'Dêgué',
        price: 4,
        category: 'Desserts',
        description: 'Mélange de yaourt et de semoule de mil.'
      },
      {
        id: 'dessert-2',
        name: 'Salade de fruits',
        price: 4,
        category: 'Desserts',
        image: IMAGES.CAPTURE_D_CRAN1617,
        description: 'Fruits frais de saison préparés avec amour.'
      },
      {
        id: 'dessert-3',
        name: 'Glace',
        price: 3.9,
        category: 'Desserts',
        description: 'Parfums : mangue, coco, vanille, chocolat.'
      }
    ]
  },
  {
    id: 'boissons',
    title: 'Boissons',
    items: [
      {
        id: 'boisson-1',
        name: 'Jus naturels (Bissap, Gingembre, Baobab)',
        price: 2.9,
        category: 'Boissons',
        description: 'Recettes artisanales rafraîchissantes.'
      },
      {
        id: 'boisson-2',
        name: 'Orange-carotte',
        price: 8,
        category: 'Boissons',
        image: IMAGES.CAPTURE_D_CRAN6623,
        description: 'Jus de fruits frais pressés.'
      },
      {
        id: 'boisson-3',
        name: 'Softs (Coca, Ice Tea, Orangina, Oasis)',
        price: 2.9,
        category: 'Boissons',
        description: 'Cannettes classiques.'
      },
      {
        id: 'boisson-4',
        name: 'Grandes bouteilles (Grenadine, Ananas, Pamplemousse)',
        price: 5,
        category: 'Boissons',
        description: 'Format idéal à partager.'
      }
    ]
  }
];